import { Center } from "@chakra-ui/react";

function Loader() {
  return (
    <Center>
      <img src="https://i.ibb.co/HrWnBqq/Infinity-1s-200px-1.gif" alt="" />
    </Center>
  );
}
export default Loader;
